export const FOOTER_HEIGHT = 64;
